/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";

import type { ScheduledReportListResponse } from "api/models";
import { getScheduledReports } from "api/services/user";
import { userQueryKeys } from "../userQueryKeys";

export const useGetScheduledReports = () =>
  useQuery<ScheduledReportListResponse>({
    queryKey: userQueryKeys.scheduledReports,
    queryFn: ({ signal }) => getScheduledReports({ signal }).then((res) => res.data),
  });
